import dynamic from 'next/dynamic';
import type { FC, HTMLAttributes } from 'react';
import type { LogoProps } from './types';
import { LogoWrapper } from './ThirdPartyLogo.styles';
import { logoMap } from './map';

type Props = {
  name: string;
  grayScale?: boolean;
} & Pick<LogoProps, 'withPadding'> &
  Pick<HTMLAttributes<HTMLDivElement>, 'className'>;

/**
 * Dynamically loads a third party logo.
 * By default the logo is positioned in a view box of 137x49.
 * This can be adjusted using the `withPadding` prop.
 */
export const ThirdPartyLogo = ({
  name,
  withPadding = 'both',
  grayScale = false,
  className,
}: Props) => {
  const logoComponent = logoMap[name.toLowerCase()];
  if (!logoComponent) {
    return null;
  }

  const LogoComponent = dynamic(async () => {
    try {
      const module = await import(`./assets/${logoComponent}`);
      return module.default;
    } catch {
      return null;
    }
  }) as FC<LogoProps> | null;

  if (!LogoComponent) {
    return null;
  }

  return (
    <LogoWrapper grayScale={grayScale} className={className}>
      <LogoComponent withPadding={withPadding} />
    </LogoWrapper>
  );
};
